import React from "react";
import { useSelector } from "react-redux";
import { BiSolidTimer } from "react-icons/bi";
import { RiLiveLine } from "react-icons/ri";
import { FaChalkboardTeacher, FaTasks, FaUniversity } from "react-icons/fa";
import {
  MdFolderSpecial,
  MdOutlineAssignmentTurnedIn,
  MdOutlineSpaceDashboard,
} from "react-icons/md";
import { LuPackagePlus } from "react-icons/lu";
import { programActions } from "../../../store/reducers/program";
import { useDispatch } from "react-redux";
import { GiStack } from "react-icons/gi";
import { MdLibraryBooks } from "react-icons/md";
import { FaEarthAmericas, FaPeopleGroup } from "react-icons/fa6";
import CustomEnrollNowButton from "../CustomEnrollNowButton";
import CircularProgress from "@mui/material/CircularProgress";
import Disclaimer from "../Disclaimer";

const FeatureIcons = {
  "live sessions": <RiLiveLine className="w-full h-full" />,
  hours: <RiLiveLine className="w-full h-full" />,
  "class hours": <RiLiveLine className="w-full h-full" />,
  "career sessions": <FaChalkboardTeacher className="w-full h-full" />,
  projects: <MdOutlineAssignmentTurnedIn className="w-full h-full" />,
  project: <MdOutlineAssignmentTurnedIn className="w-full h-full" />,
  "capstone project": <MdOutlineAssignmentTurnedIn className="w-full h-full" />,
  "capstone projects": (
    <MdOutlineAssignmentTurnedIn className="w-full h-full" />
  ),
  tools: <LuPackagePlus className="w-full h-full" />,
  modules: <MdOutlineSpaceDashboard className="w-full h-full" />,
  "core modules": <MdOutlineSpaceDashboard className="w-full h-full" />,
  "int. immersion in dubai": (
    <FaEarthAmericas className="w-full h-full" />
  ),
  "specialization modules": <MdFolderSpecial className="w-full h-full" />,
  term: <MdOutlineSpaceDashboard className="w-full h-full" />,
  assignments: <FaTasks className="w-full h-full" />,
  "campus immersion": <FaUniversity className="w-full h-full" />,
  "campus immersions": <FaUniversity className="w-full h-full" />,
  "immersion at iimv": <FaUniversity className="w-full h-full" />,
  "campus immersion (opt.)": <FaUniversity className="w-full h-full" />,
  frameworks: <GiStack className="w-full h-full" />,
  "case studies": <MdLibraryBooks className="w-full h-full" />,
  simulations: <MdLibraryBooks className="w-full h-full" />,
  "CXO coaching": <FaPeopleGroup className="w-full h-full" />,
};

const Info = () => {
  const { data, enrollLoderState } = useSelector((state) => state.program);
  const dispatch = useDispatch();

  const handleEnrollNow = () => {
    if (data) {
      dispatch(programActions.setEnrollState(data));
    }
  };

  const renderFeature = (feature) => {
    if (
      data?.key_features?.some(
        (item) => item.title.toLowerCase() === feature.title.toLowerCase()
      )
    ) {
    
      return (
        <div className="flex items-center">
          <div className="w-16 md:w-20 h-16 md:h-20 flex-shrink-0 p-4 text-universal">
            {FeatureIcons[feature.title.toLowerCase()]}
          </div>
          <div>
            <h1 className="text-lg md:text-2xl text-slate-800 font-semibold">
              {feature.count && `${feature.count}+`}
            </h1>
            <h1 className="text-lg md:text-2xl text-slate-800 font-semibold">
              {feature.text && `${feature.text}`}
            </h1>
            <h4 className="text-xs md:text-base font-medium text-neutral-600 text-nowrap capitalize">
              {feature.title}
            </h4>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="info second-bg-grad w-full flex justify-center xl:px-12 px-4 py-8 md:py-12">
      <div className="w-full max-w-[85rem]">
        <div className="w-full flex flex-col items-center">
          <h1 className="text-2xl md:text-3xl mt-2 font-semibold capitalize">
            {/* Our Unique <span className="text-universal">Educational</span> Suite */}
            Program <span className="text-universal">USPs</span> at a Glance
          </h1>
        </div>
        <div className="w-full flex gap-4 mt-6 md:mt-10 lg:flex-row flex-col max-lg:items-center">
          <div className="flex-[0.5] flex flex-col justify-between">
            <div className="mx-auto">
              <h1 className="lg:text-start text-center text-lg md:text-3xl font-semibold text-slate-800 max-w-2xl">
                Get to Know Our Program,{" "}
                <span className="text-universal">Essential Facts</span> for Your
                Consideration<span className="hidden lg:inline-block">*</span>
              </h1>
              <h4 className="lg:text-start text-center text-neutral-600 font-medium text-sm md:text-base mt-2 md:mt-4">
                Key Information for Your Evaluation
              </h4>
            </div>
            <div className="w-full py-3 hidden lg:flex items-center gap-4">
              <button className="w-full cursor-context-menu max-w-[14rem] px-4 py-2 bg-white drop-shadow-xl border border-universal rounded-md flex items-center justify-center gap-4">
                <BiSolidTimer className="text-universal" size={35} />
                <div>
                  <h1 className="font-semibold text-nowrap">
                    {/* {data?.start_date} */}
                    {data?.enrollments == "inactive"
                      ? "Coming Soon"
                      : data?.start_date}
                  </h1>
                </div>
              </button>
              {data?.enrollments === "active" ? (
                <>
                  {enrollLoderState ? (
                    <button
                      disabled={enrollLoderState}
                      //  onClick={handleEnrollNow}
                      className="px-4 py-2 h-full min-w-[100px] border-universal border drop-shadow-xl text-nowrap font-semibold rounded-md bg-universal hover:bg-darkBlue active:bg-darkBlue text-white"
                    >
                      <CircularProgress
                        size={15}
                        sx={{ color: "white" }} // Set spinner color to white
                      />
                    </button>
                  ) : (
                    <CustomEnrollNowButton
                      data={data}
                      text={"Enroll Now"}
                      className={
                        "px-4 py-2 h-full border-universal border drop-shadow-xl text-nowrap font-semibold rounded-md bg-universal hover:bg-darkBlue active:bg-darkBlue text-white"
                      }
                    />
                  )}
                </>
              ) : (
                // <button onClick={handleEnrollNow} className="px-4 py-2 h-full border-universal border drop-shadow-xl text-nowrap font-semibold rounded-md bg-universal hover:bg-darkBlue active:bg-darkBlue text-white">
                //   Enroll Now
                // </button>

                // <CustomEnrollNowButton    text={"Enroll Now"}  data={data}  className={"px-4 py-2 h-full border-universal border drop-shadow-xl text-nowrap font-semibold rounded-md bg-universal hover:bg-darkBlue active:bg-darkBlue text-white"}  />
                <>
                  {data?.enrollments === "coming-soon" ? (
                    <button className="px-4 py-2 h-full border drop-shadow-xl text-nowrap font-semibold rounded-md bg-[#AFAFAF] text-white border-slate-300 text-base cursor-not-allowed">
                      Coming Soon
                    </button>
                  ) : (
                    <button className="px-4 py-2 h-full border drop-shadow-xl text-nowrap font-semibold rounded-md bg-[#AFAFAF] text-white border-slate-300 text-base cursor-not-allowed">
                      Admission closed
                    </button>
                  )}
                </>
              )}
            </div>
            <Disclaimer ClassName={"text-sm lg:text-left text-center"} />
          </div>
          <div className="flex-[0.5] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-4">
            {data?.key_features?.map((feature, index) => (
              <React.Fragment key={index}>
                {renderFeature(feature)}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
